[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 11,
                "y": 11,
                "key": "5e9CK"
            },
            {
                "x": 11,
                "y": 11,
                "key": "vM6eU"
            },
            {
                "x": 9,
                "y": 11,
                "key": "KndBP"
            },
            {
                "x": 9,
                "y": 10,
                "key": "i1otH"
            },
            {
                "x": 8,
                "y": 10,
                "key": "yJsQD"
            },
            {
                "x": 8,
                "y": 8,
                "key": "NBPXU"
            },
            {
                "x": 9,
                "y": 8,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 9,
                "y": 7,
                "key": "6dIxq"
            },
            {
                "x": 12,
                "y": 7,
                "key": "gTp5H"
            },
            {
                "x": 12,
                "y": 10,
                "key": "enIwj"
            },
            {
                "x": 12,
                "y": 11,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    },
    {
        "key": "2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 30,
                "y": 11,
                "key": "nwBt7"
            },
            {
                "x": 30,
                "y": 10,
                "key": "_I3cW"
            },
            {
                "x": 29,
                "y": 10,
                "key": "TigtP"
            },
            {
                "x": 29,
                "y": 8,
                "key": "2_0S7"
            },
            {
                "x": 29,
                "y": 8,
                "key": "mvjqi"
            },
            {
                "x": 30,
                "y": 8,
                "key": "JZGUw"
            },
            {
                "x": 31,
                "y": 8,
                "key": "_LdZg"
            },
            {
                "x": 31,
                "y": 7,
                "key": "QHCaU"
            },
            {
                "x": 34,
                "y": 7,
                "key": "lV-BO"
            },
            {
                "x": 34,
                "y": 8,
                "key": "U_0PH"
            },
            {
                "x": 35,
                "y": 8,
                "key": "drAFU"
            },
            {
                "x": 35,
                "y": 11,
                "key": "_d3Pa"
            },
            {
                "x": 34,
                "y": 11,
                "key": "GJ1K4"
            },
            {
                "x": 34,
                "y": 12,
                "key": "pl9Yo"
            },
            {
                "x": 31,
                "y": 12,
                "key": "ZuU7B"
            },
            {
                "x": 31,
                "y": 11,
                "key": "6xogT"
            }
        ]
    },
    {
        "key": "3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 52,
                "y": 12,
                "key": "MDk-W"
            },
            {
                "x": 52,
                "y": 9,
                "key": "uVTE2"
            },
            {
                "x": 53,
                "y": 9,
                "key": "nRV2T"
            },
            {
                "x": 53,
                "y": 7,
                "key": "_d3xf"
            },
            {
                "x": 57,
                "y": 7,
                "key": "_vQYp"
            },
            {
                "x": 57,
                "y": 8,
                "key": "Wb3-3"
            },
            {
                "x": 58,
                "y": 8,
                "key": "EJwA2"
            },
            {
                "x": 58,
                "y": 12,
                "key": "QPUVq"
            },
            {
                "x": 57,
                "y": 12,
                "key": "c-_Lp"
            },
            {
                "x": 57,
                "y": 13,
                "key": "z9gUM"
            },
            {
                "x": 56,
                "y": 13,
                "key": "j6XSw"
            },
            {
                "x": 55,
                "y": 13,
                "key": "ICDgI"
            },
            {
                "x": 53,
                "y": 13,
                "key": "Q7gQR"
            },
            {
                "x": 53,
                "y": 12,
                "key": "UGcDc"
            }
        ]
    },
    {
        "key": "a",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": -21,
                "y": 10,
                "key": "7SKJN"
            },
            {
                "x": -21,
                "y": 7,
                "key": "Nl8Va"
            },
            {
                "x": -18,
                "y": 7,
                "key": "sWYgA"
            },
            {
                "x": -18,
                "y": 8,
                "key": "MGvpd"
            },
            {
                "x": -17,
                "y": 8,
                "key": "GNk3r"
            },
            {
                "x": -17,
                "y": 11,
                "key": "cenpn"
            },
            {
                "x": -20,
                "y": 11,
                "key": "XAgTJ"
            },
            {
                "x": -21,
                "y": 11,
                "key": "vhxey"
            }
        ]
    }
]